export const COLORS = {
  colorPrimary: '#36a3f7',
  colorBrandYellow: '#f0ae00',
  colorBrandGreen: '#52b480',
  colorBrandRed: '#d0021b',
  colorBrandBlue: '#2b527d',
  colorBrandPurple: '#5d4698',
  colorWhite: '#ffffff',
  colorLightBlue: '#505d68',
  colorBrandDarkGrey: '#424b5a',
  colorToolbar: '#cccccc',
};
